import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimDocument.Delete.IRequest;
type Response = Api.Core.ClaimDocument.Delete.IResponse;
type Headers = Api.Core.ClaimDocument.Delete.IHeaders;
const url = '/api/Claims/Claim/:id/Documents/:documentId';
export default async function claimDocumentDeleteApi(params: {
  id: number;
  documentId: number;
}): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
